import { useCallback } from 'react';
import type { ElasticListVehicle } from '@//app/api/search/vehicles';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackProductClickEventData } from './legacy-types';
import { mapElasticVehicleOrElasticListVehicleToLegacyItem } from './utils';

interface UseLegacyTrackProductClickVariables {
  vehicle: ElasticVehicle | ElasticListVehicle;
  information: LegacyTrackProductClickEventData['information'];
}

export const createLegacyTrackProductClick = (
  market: Market,
  variables: UseLegacyTrackProductClickVariables,
): LegacyTrackProductClickEventData => {
  const eventData: LegacyTrackProductClickEventData = {
    eventType: 'productClick',
    item: mapElasticVehicleOrElasticListVehicleToLegacyItem(market, variables.vehicle),
    information: variables.information,
    list: 'SOK',
  };

  return eventData;
};

export const useLegacyTrackProductClick = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();

  const trackLegacyProductClick = useCallback(
    (variables: UseLegacyTrackProductClickVariables) => {
      track({
        event: 'productClick',
        data: createLegacyTrackProductClick(market, variables),
      });
    },
    [track],
  );

  return {
    trackLegacyProductClick,
  };
};
